// extracted by mini-css-extract-plugin
export default {"qa_box":"index_qa_box_jqOxl","user":"index_user_P8YpR","qalist":"index_qalist_hZ7Mz","question":"index_question_pPypI","answer":"index_answer_3MCZh"};